/**
 * Gets the initial values for the formik forms
 */
export default function getInitialValues(value: string | undefined) {
  if (value) {
    return value;
  }
  return undefined;
}
